import React, { useState, Fragment } from "react";
import { withCookies } from "react-cookie";
import { withRouter } from "react-router-dom";
import Traductor from "../components/Traductor";
import ScrollToTop from "../components/ScrollToTop";
import Accordion from "../components/bronson/Accordion";
import Input from "../components/bronson/Input";
import faqs from "../json/faqs.json";
import "../css/pages/faqspage.css";

const FaqsPage = () => {
  const t = new Traductor();

  const [valueInput, setValueInput] = useState("");

  let inputOptions = {
    id: "page-search-bar",
    className: "c-input__input",
    isRequired: false,
    value: valueInput,
    type: "text",
    backButton: {
      type: "semantic-search",
    },
  };

  const onChangeInput = (e) => {
    let newValue = e;
    setValueInput(newValue);
  };

  const onPressKeyEnter = (e) => {
    if (e.charCode === 13) {
      onSearchText();
    }
  };

  const printAccordions = () => {
    let listAccordions = [];
    faqs.Faqs.Rema.map((itemRema, i) =>
      listAccordions.push(
        <Fragment key={i}>
          <h3 className="u-mt-xlarge u-mb h3-principal-title" key={i}>
            {itemRema.Head}
          </h3>
          {itemRema.Accordions.map((item, j) => (
            <Accordion option={item} key={j} id={"faq-" + i + "-" + j} />
          ))}
        </Fragment>
      )
    );

    return listAccordions;
  };

  const onRemoveMark = () => {
    let arrayHeadTitles = document.getElementsByClassName("h3-principal-title");
    let arrayAccordionContents = document.getElementsByClassName(
      "c-accordion__content"
    );
    let arrayTitlesdoc = document.getElementsByClassName("c-accordion__title");

    for (let k = 0; k < arrayHeadTitles.length; k++) {
      arrayHeadTitles[k].innerHTML = arrayHeadTitles[k].innerHTML.replace(
        "<mark>",
        ""
      );
      arrayHeadTitles[k].innerHTML = arrayHeadTitles[k].innerHTML.replace(
        "</mark>",
        ""
      );
    }

    for (let index = 0; index < arrayAccordionContents.length; index++) {
      let strIdElement = arrayAccordionContents[index].id;
      let arrayChildrenObject = arrayAccordionContents[index].children;

      arrayTitlesdoc[index].innerHTML = arrayTitlesdoc[index].innerHTML.replace(
        "<mark>",
        ""
      );
      arrayTitlesdoc[index].innerHTML = arrayTitlesdoc[index].innerHTML.replace(
        "</mark>",
        ""
      );

      for (let j = 0; j < arrayChildrenObject.length; j++) {
        arrayAccordionContents[index].children[
          j
        ].innerHTML = arrayAccordionContents[index].children[
          j
        ].innerHTML.replace("<mark>", "");
        arrayAccordionContents[index].children[
          j
        ].innerHTML = arrayAccordionContents[index].children[
          j
        ].innerHTML.replace("</mark>", "");
      }

      let elemHeadButton = document.getElementById(
        "head-button-" +
          strIdElement.substring(
            strIdElement.indexOf("-") + 1,
            strIdElement.length
          )
      );
      let elemHead = document.getElementById(
        "head-" +
          strIdElement.substring(
            strIdElement.indexOf("-") + 1,
            strIdElement.length
          )
      );
      let elemBody = document.getElementById(
        "body-content-" +
          strIdElement.substring(
            strIdElement.indexOf("-") + 1,
            strIdElement.length
          )
      );

      if (elemHeadButton.attributes["aria-expanded"].value === "true") {
        elemHeadButton.attributes["aria-expanded"].value = "false";
      }

      if (elemBody.attributes["aria-hidden"].value === "false") {
        elemBody.attributes["aria-hidden"].value = "true";
        let strauxBody = elemBody.attributes["class"].value;
        strauxBody = strauxBody + " is-closed";
        elemBody.attributes["class"].value = strauxBody;
        elemBody.attributes["style"].value =
          "height: 0px; visibility: hidden; overflow-y: hidden;";
      }

      let straux = elemHead.attributes["class"].value;
      if (straux.indexOf("is-active") !== -1) {
        elemHead.attributes["class"].value = straux.replace("is-active", "");
      }
    }
  };

  const onSearchText = (e) => {
    onRemoveMark();
    let arrayHeadTitles = document.getElementsByClassName("h3-principal-title");
    let arrayAccordionContents = document.getElementsByClassName(
      "c-accordion__content"
    );
    let arrayTitlesdoc = document.getElementsByClassName("c-accordion__title");

    for (let k = 0; k < arrayHeadTitles.length; k++) {
      let elementHeadTitle = arrayHeadTitles[k].innerHTML
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
      if (
        elementHeadTitle.toUpperCase().indexOf(valueInput.toUpperCase()) !== -1
      ) {
        let textoreplaceHead = arrayHeadTitles[k].innerHTML.substring(
          elementHeadTitle.toUpperCase().indexOf(valueInput.toUpperCase()),
          elementHeadTitle.toUpperCase().indexOf(valueInput.toUpperCase()) +
            valueInput.length
        );
        arrayHeadTitles[k].innerHTML = arrayHeadTitles[k].innerHTML.replace(
          textoreplaceHead,
          "<mark>" + textoreplaceHead + "</mark>"
        );
      }
    }

    for (let index = 0; index < arrayAccordionContents.length; index++) {
      let element = arrayAccordionContents[index].innerHTML
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
      let elementTitle = arrayTitlesdoc[index].innerHTML
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");

      let strIdElement = arrayAccordionContents[index].id;

      if (elementTitle.toUpperCase().indexOf(valueInput.toUpperCase()) !== -1) {
        let textoreplace = arrayTitlesdoc[index].innerHTML.substring(
          elementTitle.toUpperCase().indexOf(valueInput.toUpperCase()),
          elementTitle.toUpperCase().indexOf(valueInput.toUpperCase()) +
            valueInput.length
        );
        arrayTitlesdoc[index].innerHTML = arrayTitlesdoc[
          index
        ].innerHTML.replace(textoreplace, "<mark>" + textoreplace + "</mark>");
      }

      if (element.toUpperCase().indexOf(valueInput.toUpperCase()) !== -1) {
        let arrayChildrenObject = arrayAccordionContents[index].children;
        for (let j = 0; j < arrayChildrenObject.length; j++) {
          let objText = arrayAccordionContents[index].children[j].innerHTML
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");
          if (objText.toUpperCase().indexOf(valueInput.toUpperCase()) !== -1) {
            let textoreplace = arrayChildrenObject[j].innerHTML.substring(
              objText.toUpperCase().indexOf(valueInput.toUpperCase()),
              objText.toUpperCase().indexOf(valueInput.toUpperCase()) +
                valueInput.length
            );
            arrayAccordionContents[index].children[
              j
            ].innerHTML = arrayAccordionContents[index].children[
              j
            ].innerHTML.replace(
              textoreplace,
              "<mark>" + textoreplace + "</mark>"
            );
          }
        }
        let elem = document.getElementById(
          "head-button-" +
            strIdElement.substring(
              strIdElement.indexOf("-") + 1,
              strIdElement.length
            )
        );
        elem.click();
      }
    }
  };

  return (
    <Fragment>
      <ScrollToTop></ScrollToTop>
      <div
        className="c-hero-teaser c-hero-teaser--shallow"
        data-testid="faqsPageTestId"
      >
        <img
          id="imagen_contactpage"
          className="c-hero-teaser__image"
          src={
            process.env.PUBLIC_URL + "/Bronson/img/imgHeaders/Header-faqs.jpg"
          }
          sizes="100vw"
          alt="img header"
        ></img>
        <div id="js-hero-teaser-content" className="c-hero-teaser__content ">
          <div className="c-hero-teaser__content-inner">
            <header className="c-hero-teaser__heading">
              <div className="c-hero-teaser__title">
                <h1>
                  <span className="c-hero-teaser__title-row ">
                    {t.getTraduction("Faqs")}
                  </span>
                  <br />
                </h1>
              </div>
            </header>
          </div>
        </div>
      </div>
      <main className="o-main">
        <section className="o-content-section">
          <div className="o-page-wrap o-page-wrap--xxsmall">
            <h2 className="u-text-center u-mb">
              &nbsp; <br />
              Bienvenido a Rema 4.0
            </h2>
            <p>
              Rema 4.0 es la web de venta de vehículos de ocasión de Volkswagen
              Financial Services.
            </p>
            <p>
              El mejor lugar para encontrar vehículos de todas las marcas del
              Grupo Volkswagen procedentes de nuestro portfolio de productos y a
              un precio inigualable gracias a nuestro sistema de pujas y lotes.
            </p>
            <p>
              La mayoría de nuestros vehículos proceden de Renting donde los
              mantenimientos y revisiones se han realizado siempre en Servicio
              Oficial y disponen de sus historiales para su consulta.
            </p>
            <p>
              Rema 4.0 es un servicio exclusivo para empresas y profesionales
              que ya puedes empezar a disfrutar.{" "}
            </p>
            <p>
              {" "}
              Y si tienes alguna duda, no dudes en contactarnos para resolverla.
            </p>
          </div>
        </section>
        <section className="o-content-section u-pt-none u-mb-xlarge faq-page-css">
          <div className="o-page-wrap  o-page-wrap--xxsmall">
            <div className="o-layout">
              <div className="o-layout__item u-1/1">
                <h5>Te podemos ayudar?</h5>
              </div>
              <div className="o-layout__item u-1/1">
                <Input
                  options={inputOptions}
                  value={valueInput}
                  onChange={(e) => onChangeInput(e)}
                  onKeyPress={(e) => onPressKeyEnter(e)}
                  onclickbackbutton={(e) => onSearchText(e)}
                />
              </div>
              <div className="o-layout__item u-1/1">{printAccordions()}</div>
            </div>
          </div>
        </section>
      </main>
    </Fragment>
  );
};
export default withCookies(withRouter(FaqsPage));
